<template>
  <BaseField baseRule="" v-bind="$attrs" readonly :label="label" :placeholder="placeholder" v-model="inputValue">
    <template v-slot:afterInput>
      <button type="button" class="btn-sm" :disabled="choiceDisable" @click="openChoiceForm">選択</button>
      <slot name="afterInput" />
    </template>
  </BaseField>
</template>

<script>
import { mapActions } from 'vuex';
import BaseField from '@/components/forms/BaseField.vue';

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    modelFieldName: {
      type: String,
      required: true,
    },
    childFieldNames: {
      type: Array,
      default: () => [],
    },
    resourceType: {
      type: String,
      required: true,
    },
    excludeItems: {
      type: Object,
      default: () => {},
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    choiceDisable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseField,
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    openChoiceForm() {
      let data = {
        modelFieldName: this.modelFieldName,
        formData: this.formData,
        prevRouteName: this.$route.fullPath,
        childFieldNames: this.childFieldNames,
        excludeItems: this.excludeItems,
      };

      this.$logger.debug('Storing current form data', data);
      this.storeFormData(data);
      this.$router.push({ name: 'choice', params: { resourceType: this.resourceType } });
    },
    ...mapActions('form', ['storeFormData']),
  },
};
</script>
